import { render, staticRenderFns } from "./MenuActions.vue?vue&type=template&id=eaafb2e0"
import script from "./MenuActions.vue?vue&type=script&lang=js"
export * from "./MenuActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports